import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Droplets, Calendar, ClipboardList, StickyNote } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavItem {
  path: string;
  label: string;
  icon: React.ReactNode;
}

const navItems: NavItem[] = [
  {
    path: '/',
    label: 'Drops',
    icon: <Droplets size={20} />
  },
  {
    path: '/screen2',
    label: 'Planned',
    icon: <ClipboardList size={20} />
  },
  {
    path: '/screen3',
    label: 'Notes',
    icon: <StickyNote size={20} />
  },
  {
    path: '/calendar',
    label: 'Calendar',
    icon: <Calendar size={20} />
  }
];

const BottomNavigation: React.FC = () => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background" style={{backgroundColor: '#0f172a'}}>
      <div className="flex justify-around items-center h-16 px-4">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center space-y-1 px-3 py-2 rounded-lg transition-colors",
                isActive
                  ? "text-white bg-white/20"
                  : "text-gray-300 hover:text-white hover:bg-white/10"
              )}
            >
              {item.icon}
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
